
    import StepContainer from './common/StepContainer.vue'
    import Vue from 'vue'
    import TextInputButton from './common/TextInputButton.vue'
    import TextAreaButton from './common/TextAreaButton.vue'
    import TipsSelector from './common/TipsSelector.vue'
    import ThankYouInfoSelector from './common/ThankYouInfoSelector.vue'
    import RepeatingStepLogic from './common/RepeatingStepLogic'
    import HelperMethods from './common/HelperMethods'
    import ContentDisplayClosed from './common/ContentDisplayClosed.vue'
    import ExternalLinkSelector from './common/ExternalLinkSelector.vue'
    import RatingScaleSelector from './common/RatingScaleSelector.vue'
    import info from "./common/SVGs/Info.vue";    
    import globe from "./common/SVGs/Globe.vue";    
    import Googlereview from "../../platformlogos/Googlereview.vue";
    import Facebook from "../../platformlogos/Facebook.vue";

    export default Vue.extend({
        //--------
        data () {
            return {
                
            }
        },
        mixins: [HelperMethods, RepeatingStepLogic],
        //--------
        created (): void {            

        },
        //---------
        computed: {
            closedSideCntnt (): any[] | boolean {
                const toReturn = [] as any[]

                //check if we have any external links set up:
                const externalLinks = this.$store.getters["survey/stepField"]([this.compIndex, 'externalLinks'])
                if (externalLinks) {
                    externalLinks.forEach((eL) => {
                        toReturn.push({
                            key: 'el',
                            count: externalLinks.length
                        })
                    })
                }

                //check if we have any links, or enabled Facebook/Google info
                const currrentInfoConfig = this.$store.getters["survey/stepField"]([this.compIndex, 'thankYouInfo'])
                if (currrentInfoConfig) {                    

                    currrentInfoConfig.forEach((info) => {
                        toReturn.push({
                            key: info.key
                        })
                    })

                } else {
                    return false
                }

                return toReturn
            }
        },
        //---------
        props: {
            compIndex: Number,
            isDisabled: Boolean        
        },
        //--------
        components: {
            surveystep: StepContainer,
            TextInputButton,
            TextAreaButton,
            TipsSelector,
            ThankYouInfoSelector,
            ContentDisplayClosed,
            ExternalLinkSelector,
            RatingScaleSelector,
            info,
            globe,
            gp: Googlereview,
            fb: Facebook
        },
        //--------
        methods: {
                    
            getItemPic(key: string) : string {
                switch (key) {                    
                    case 'contact':
                        return 'info'
                    case 'el':
                        return 'globe'
                    default:
                        return key                    
                }
            }

            }
        })
